import {
  Box,
  Button,
  HStack,
  Img,
  Square,
  Stack,
  Text,
  Link,
} from '@chakra-ui/react';
import React, { useContext, useEffect, useState } from 'react';
import Container from '../../../components/Container';
import Header from '../../../components/Header';
import car from '../../../assets/car.png';
import Footer from '../../../components/footer';
import { Success } from '../../../components/Success';
import { useParams } from 'react-router-dom';
import { AuthContext } from '../../../context/authContext';
import { getSingleAdvertProduct } from '../service/topProducts';
import FullPageLoader from '../../../components/FullPageLoader';
import { v4 } from 'uuid';
import { PROTECTED_PATHS } from '../../../app/constants';
import CustomModal from '../../../components/CustomModal';
import SendMessage from './SendMessage';

const TopProductInfo = () => {
  const { productId } = useParams();
  const [success] = useState(false);
  const { userInfo } = useContext(AuthContext);
  const { userId } = userInfo;
  const [singleTopProductDetails, setSingleTopProductDetails] = useState({});
  const [loading, setLoading] = useState(false);
  const { MARKET_PLACE } = PROTECTED_PATHS;

  useEffect(() => {
    getSingleAdvertProduct(
      userId,
      productId,
      setLoading,
      setSingleTopProductDetails
    );
  }, [userId, productId]);

  return (
    <>
      {!success && loading && <FullPageLoader />}

      {success && !loading && <Success />}

      {!loading && !success && (
        <Box>
          <Box shadow='sm'>
            <Container>
              <Header goto={MARKET_PLACE} />
            </Container>
          </Box>
          <Container>
            <Box py='8'>
              <Img
                borderRadius='10px'
                w='100%'
                objectFit='cover'
                shadow='lg'
                h='250px'
                src={
                  singleTopProductDetails?.imageUrl?.length > 0
                    ? singleTopProductDetails?.imageUrl[0]
                    : car
                }
                alt={singleTopProductDetails?.itemName || 'car'}
              />
            </Box>
            <HStack gap='0.8rem' wrap='wrap'>
              {singleTopProductDetails?.imageUrl?.length &&
                singleTopProductDetails?.imageUrl
                  ?.slice(1)
                  ?.map((topProd) => (
                    <Img
                      key={v4()}
                      w='100px'
                      h='100px'
                      objectFit='cover'
                      shadow='lg'
                      borderRadius='5px'
                      src={topProd ? topProd : car}
                      alt='car'
                    />
                  ))}
            </HStack>
            <Stack color='#7A7A7A' my='5'>
              <Text fontWeight='900' fontSize='1.4rem'>
                {singleTopProductDetails?.itemName}
              </Text>
              <Text>{singleTopProductDetails?.itemDescription}</Text>
              <HStack justify='space-between'>
                <Text fontSize='1.5rem' fontWeight='900'>
                  &#8358; {singleTopProductDetails?.price}
                </Text>
                <Square py='1' px='2'>
                  <Text pr='2' fontSize='1rem' fontWeight='800'>
                    Qty
                  </Text>
                  <Text
                    p='2'
                    borderRadius='5px'
                    bg='#FEE4B8'
                    fontWeight='bold'
                    fontSize='1rem'
                  >
                    {singleTopProductDetails?.quantity}
                  </Text>
                </Square>
              </HStack>
            </Stack>
            <HStack pb='20' justify='space-between' gap='1rem'>
              <CustomModal
                buttonProps={{
                  border: '1px solid #FEE4B8',
                  bg: '#f7f7ff',
                  color: 'primary',
                  w: '50%',
                }}
                btnTitle='Send Message'
              >
                <SendMessage
                  singleTopProductDetails={singleTopProductDetails}
                />
              </CustomModal>

              <Link
                w='50%'
                h='100%'
                href={`tel:${singleTopProductDetails?.phoneNumber}`}
              >
                <Button
                  w='100%'
                  align='center'
                  p='0'
                  bg='primary'
                  _hover={{ bg: 'primary' }}
                  color='#fff'
                >
                  <Text>Call now</Text>
                </Button>
              </Link>
            </HStack>
          </Container>
          <Footer />
        </Box>
      )}
    </>
  );
};

export default TopProductInfo;
